import { GetMemoDetail } from "../../../../Services/MemoService";

export async function getTemplateById(templateId: number) {
  const memoResponse: MemoResponse = await GetMemoDetail({
    Memoid: 0,
    TemplateId: templateId,
    DocumentCode: "",
    SecretId: "",
    DocumentNo: "",
    EmployeeId: "1",
    actor: {
      EmployeeId: 1,
    },
  });

  const strAdvanceForm = memoResponse.requestDetails.listFormNames
    ? memoResponse.requestDetails.listFormNames[0].AdvanceForm
    : null;
  const subject = memoResponse.requestDetails.listFormNames
    ? memoResponse.requestDetails.listFormNames[0].TemplateSubject
    : null;
  if (strAdvanceForm == null) {
    return null;
  }
  const advanceForm: AdvanceForm = JSON.parse(strAdvanceForm) ?? null;
  return { advanceForm, subject };
}
